/**
 * Typy filtrů zobrazovaných features.
 */
export enum FeatureFilterType {
    /**
     * Vrátí Ids features zobrazených v rozsahu obrazovky dané vrstvy.
     */
    SHOW_EXTENT = 'SHOW_EXTENT'
}